<template>
    <div class="flex flex-col py-4">
        <vs-col vs-w="12" vs-type="flex" vs-align="center" vs-justify="space-between">
            <div class="flex">
                <feather-icon
                    class="mr-2"
                    icon="AwardIcon"
                    svgClasses="text-black stroke-current w-36.96 h-36.96"
                ></feather-icon>
                <h4>Experiências</h4>
            </div>

            <vs-button
                class="mobile-hidden"
                size="small"
                color="primary"
                type="border"
                icon="edit"
                @click="$router.push({ name: 'edit-experiences' })"
            >
                Editar
            </vs-button>
            
            <vs-button
                class="sm:hidden"
                size="small"
                color="primary"
                type="border"
                icon="edit"
                @click="$router.push({ name: 'edit-experiences' })"
            />
        </vs-col>

        <hr class="my-4 line"/>

        <ul v-if="show()" class="activity-timeline">
            <li v-for="(experience, index) in experiencies" :key="`step-${index}`">
                <div class="timeline-icon" :style="{backgroundColor: color}" :key="`timeline-${index}`">
                    <feather-icon icon="BriefcaseIcon" svgClasses="text-white stroke-current w-5 h-5"></feather-icon>
                </div>
                <div
                    class="exp-detail__date"
                    v-if="experience.from_date != null || experience.from_date != undefined &&
                        experience.to_date != null || experience.to_date != undefined &&
                        experience.period != null || experience.period != undefined"
                >
                    {{
                        (experience.from_date) ? 
                            'De ' + experience.from_date
                            .concat(` até ${experience.is_current ? 'atualmente' : experience.to_date}`)
                            .concat(
                                experience.is_current
                                    ? '' 
                                    : ` (${experience.period})`
                            )
                        :
                        (
                            ((experience.from_date === null || experience.from_date === undefined) && experience.to_date) 
                                ? 'Início Não Informado - ' + experience.to_date
                                : experience.from_date + '- Não Informado' )
                    }}
                </div>
                <div
                    class="exp-detail__company"
                    v-if="experience.business_role != null || experience.business_role != undefined &&
                        exprience.company != null || experience.company != undefined"
                >
                    {{
                        experience.business_role + " - " + experience.company
                    }}
                </div>
                <div
                    class="exp-detail__description"
                    v-if="experience.description != null || experience.description != undefined"
                >
                    {{ experience.description }}
                </div>
                <div v-if="experience.skills.length > 0" class="exp-detail--skills">
                    <span class="exp-detail--skills__title">Habilidades e Ferramentas:</span>
                    <div class="exp-detail--skills__chip" :style="{color: color, borderColor: color}">
                        <div class="chip" v-for="(skill, index) in experience.skills" :key="`chip-${index}`">
                            {{ skill }}
                        </div>
                    </div>
                </div>
            </li>
        </ul>
        <EmptyDetailCard
            v-else
            description="Você ainda não preencheu nenhuma informação de experiências..."
        />
    </div>
</template>

<script>
import { get } from 'lodash';
import { mapState } from 'vuex';

import EmptyDetailCard from '@/components/dashboard/profile-detail/EmptyDetailCard';

export default {
    name: 'experience-detail-card',
    computed: {
        ...mapState('experience', ['experiencies']),
        ...mapState('company', ['company']),

        color() {
            return get(this.$store, 'state.company.base_hexcolor', '#1551b1');
        },
    },
    methods: {
        show() {
            return this.experiencies.length > 0
        }
    },

    components: {
        EmptyDetailCard
    },
}
</script>

<style lang="scss">
@import '@/assets/scss/talent/components/experiencedetailcard.scss';

hr{
    height: 1px;
    background-color: rgba(0, 0, 0, 0.1);
    border: none;
}
</style>